import React, { useState, useEffect, useCallback } from 'react';
import SideNav from "../common/sidenav"; // Corrected the import
import TopNav from "../common/topnav";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../http/authcontex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loading from "../loading/loading";
import Select from 'react-select'; // Import react-select
import './report.css'; // Assuming you will add your custom styles


import { bankProgressReport, showDistinctBank, stateList } from "../http/api";

export default function Report() {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const authContext = useAuth();

    // Sidebar toggle state
    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [reportType, setReportType] = useState('');
    const [state, setState] = useState('');
    const [city, setCity] = useState('');
    const [, setAccountName] = useState('');
    const [bankName, setBankName] = useState(''); // Declare bankName state

    const handleReportTypeChange = (selectedOption) => {
        setReportType(selectedOption ? selectedOption.value : '');
        if (selectedOption && selectedOption.value === 'Progress Report') {
            // Show state and city fields for progress report
            setState('');
            setCity('');
        }
    };

    const handleChange = (event) => {
        const { name, value } = event.target;
        // Update the state dynamically based on the name of the input field
        if (name === "state") {
            setState(value);
        } else if (name === "city") {
            setCity(value);
        } else if (name === "accountName") {
            setAccountName(value);
        } else if (name === "bankName") {
            setBankName(value);
        }
    };


    // Handle State Change for Branch Office
    const handleStateChange = (selectedOption) => {
        handleChange({ target: { name: "state", value: selectedOption.value } });
        handleChange({ target: { name: "city", value: "" } }); // Clear city when state changes

        // Populate city dropdown based on selected state
        setCityOptions(selectedOption.cities || []);
    };

    // Handle City Change for Branch Office
    const handleCityChange = (selectedOption) => {
        handleChange({ target: { name: "city", value: selectedOption.value } });
    };


    const [bankOptions, setBankOptions] = useState([]);
    // Fetch Designation Details
    const viewBankDetails = useCallback(() => {
        setLoading(true);
        showDistinctBank()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success ", response.data);
                    const bankOptions = response.data.map(bankName => ({
                        value: bankName,
                        label: bankName
                    }));
                    setBankOptions(bankOptions); // Set bankOptions state
                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching designation details:', error);
                }
            });
    }, [authContext, navigate]);

    // useEffect to fetch designations on mount
    useEffect(() => {
        viewBankDetails();
    }, [viewBankDetails]);


    const handleSubmit = () => {

        setLoading(true);

        // Call the API

        bankProgressReport(bankName, state, city)
            .then((response) => {
                setLoading(false);
                console.log("response.status " + response);

                if (response.status === 200) {

                    console.log("response.data " + response.data);
                    const byteArray = new Uint8Array(response.data);  // Convert the response.data to a byte array (if not already)

                    console.log("byteArray " + byteArray);

                    // Use a fixed content type for Excel file
                    const contentType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"; // For Excel files

                    // Create a Blob from the byte array
                    const blob = new Blob([byteArray], {
                        type: contentType,
                    });

                    // Create a temporary link to download the file
                    const link = document.createElement("a");
                    link.href = URL.createObjectURL(blob); // Create a URL for the Blob

                    const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
                    const filename = `BankwiseProgressReport_${currentDate}.xlsx`;
                    link.download = filename; // Set the filename

                    // Append the link to the body (necessary for the click to work)
                    document.body.appendChild(link);

                    // Programmatically click the link to trigger the download
                    link.click();

                    // Remove the link after the download starts
                    document.body.removeChild(link);

                    toast.success("Report generated successfully!", {
                        position: "top-right",
                        autoClose: 3000,
                    });

                } else {
                    toast.error("Failed to generate the report. Please try again.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            })
            .catch((error) => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // Handle unauthorized error
                    console.error("Unauthorized access. Redirecting to login...");
                    authContext.logout();
                    navigate('/');
                } else {
                    console.error("Error generating report:", error);
                    toast.error("Error generating report. Please try again later.", {
                        position: "top-right",
                        autoClose: 3000,
                    });
                }
            });
    };

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    // State options
    const [stateOptions, setStateOptions] = useState([]);

    // City options
    const [cityOptions, setCityOptions] = useState([]);

    // Fetch State and City Details
    const viewStateDetails = useCallback(() => {
        setLoading(true);
        stateList()
            .then(response => {
                if (response.status === 200) {
                    console.log("response : success ", response.data);
                    const states = response.data;
                    // Transform states and cities for dropdown
                    const stateDropdownOptions = states.map(state => ({
                        value: state.name,
                        label: state.name,
                        cities: state.cities.map(city => ({
                            value: city.name,
                            label: city.name,
                        })),
                    }));

                    setStateOptions(stateDropdownOptions);

                    setLoading(false);

                }

            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    // If 401 Unauthorized, redirect to login
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout()
                    navigate('')
                } else {
                    // Handle other errors
                    console.error('Error fetching state details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewStateDetails();
    }, [viewStateDetails]);

    // Inside your component function

    const handleBankNameChange = (selectedOption) => {
        setBankName(selectedOption ? selectedOption.value : ''); // Update bank name
    };


    return (
        <div className="Reports">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? "sb-sidenav-toggled" : ""}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNav isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Report</h4>
                                <hr className="bg-warning" style={{ height: "4px" }} />
                                <div className="card mb-4" style={{ maxWidth: '700px', margin: '0 auto' }}>
                                    <div className="card-body shadow-sm border-0">
                                        {/* Report Type Dropdown */}
                                        <div className="mb-3">
                                            <label htmlFor="reportType" className="form-label">Report Type</label>
                                            <Select
                                                id="reportType"
                                                value={reportType ? { value: reportType, label: reportType } : null}
                                                onChange={handleReportTypeChange}
                                                options={[
                                                    { value: '', label: 'Select Report Type' },
                                                    { value: 'Progress Report', label: 'Progress Report' }
                                                ]}
                                                placeholder="Select Report Type"
                                            />
                                        </div>


                                        {/* Conditional Fields for Progress Report */}
                                        {reportType === 'Progress Report' && (
                                            <>

                                                {/* Bank Name Dropdown */}
                                                <div className="mb-3">
                                                    <label htmlFor="bankName" className="form-label">Bank Name</label>
                                                    <Select
                                                        id="bankName"
                                                        value={bankName ? { value: bankName, label: bankName } : null}
                                                        onChange={handleBankNameChange}
                                                        options={bankOptions}
                                                        placeholder="Select Bank Name"
                                                    />
                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="state" className="form-label">State</label>
                                                    <Select
                                                        name="state"
                                                        value={stateOptions.find(option => option.value === state) || null}  // Fix here
                                                        onChange={handleStateChange}
                                                        options={stateOptions}
                                                        placeholder="Select State"
                                                        isSearchable
                                                    />

                                                </div>
                                                <div className="mb-3">
                                                    <label htmlFor="city" className="form-label">City</label>
                                                    <Select
                                                        name="zonalOffice.city"
                                                        value={cityOptions.find(option => option.value === city) || null}
                                                        onChange={handleCityChange}
                                                        options={cityOptions}
                                                        placeholder="Select City"
                                                        isSearchable
                                                        isDisabled={!state} // Disable if state is not selected
                                                    />
                                                </div>
                                            </>
                                        )}

                                        {/* Account Name Dropdown
                                        <div className="mb-3">
                                            <label htmlFor="accountName" className="form-label">Account Name</label>
                                            <Select
                                                id="accountName"
                                                value={accountName ? { value: accountName, label: accountName } : null}
                                                onChange={handleAccountNameChange}
                                                options={accountOptions}
                                                placeholder="Select Account Name"
                                            />
                                        </div> */}

                                        <button
                                            className="btn btn-primary w-100"
                                            onClick={handleSubmit}
                                            disabled={!reportType || !bankName || (reportType === 'Progress Report' && (!state || !city))}
                                        >
                                            Generate Report
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>

            {/* ToastContainer */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
